import { useState, useEffect } from "react";
import { ApiService } from "../../services/ApiService";
import { IChallenge } from "../../models/IChallenge";

export function useChallenges(theme?: string) {
  const [isLoading, setIsLoading] = useState(false);
  const [challenges, setChallengeList] = useState<IChallenge[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(
    false
  );

  const fetchData = async () => {
    let api = new ApiService();

    try {
      let items = theme
        ? await api.GetChallengesByTheme(theme, pageNumber)
        : await api.GetChallenges(pageNumber);

      if (items) {
        setPageNumber(pageNumber + 1);
        setChallengeList([...challenges, ...items]);
        setIsLoading(false);
        setDisableInfiniteScroll(items.length < 10);
      }
    } catch {
      // TODO - add error message
      console.log("Oops something went wrong");
      setIsLoading(false);
    }
  };

  const loadMore = async ($event: CustomEvent<void>) => {
    await fetchData();
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    disableInfiniteScroll,
    challenges,
    isLoading,
    loadMore,
  };
}
